export const decodeUnicode = (str) => {
  if (typeof str === 'string') {
    return str.replace(/\\u[\dA-F]{4}/gi, (match) =>
      String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
    );
  }
  return str;
};

export const languageMapping = {
  С: 'Srpski - Ćirilica',
  Х: 'Hrvatski',
  М: 'Mađarski',
  Л: 'Srpski - Latinica',
  Р: 'Rumunski'
};

export const roleMapping = {
  1: 'Admin',
  2: 'Nastavnik PMF',
  3: 'Skola'
};

export const languageMappingboth = {
  sr: {
    С: 'Srpski',
    Х: 'Hrvatski',
    М: 'Mađarski',
    Л: 'Latinski',
    Р: 'Rumunski'
  },
  cy: {
    С: 'Српски',
    Х: 'Хрватски',
    М: 'Мађарски',
    Л: 'Латински',
    Р: 'Румунски'
  }
};

export const genderMapping = {
  sr: {
    M: 'Muški',
    Z: 'Ženski'
  },
  cy: {
    M: 'Мушки',
    Z: 'Женски'
  }
};

export const genderMappingPDF = {
  m: 'Мушки',
  z: 'Женски'
};
export const truncateMessage = (message, maxLength = 100) => {
  return message.length > maxLength
    ? `${message.slice(0, maxLength)}...`
    : message;
};

export const decodeHtmlEntities = (text) => {
  const element = document.createElement('div');
  if (text) {
    element.innerHTML = text;
    return element.textContent || element.innerText || '';
  }
  return '';
};

export const cyrillicToLatin = (text) => {
  const cyrillicMap = {
    А: 'A',
    а: 'a',
    Б: 'B',
    б: 'b',
    В: 'V',
    в: 'v',
    Г: 'G',
    г: 'g',
    Д: 'D',
    д: 'd',
    Ђ: 'Đ',
    ђ: 'đ',
    Е: 'E',
    е: 'e',
    Ж: 'Ž',
    ж: 'ž',
    З: 'Z',
    з: 'z',
    И: 'I',
    и: 'i',
    Ј: 'J',
    ј: 'j',
    К: 'K',
    к: 'k',
    Л: 'L',
    л: 'l',
    Љ: 'Lj',
    љ: 'lj',
    М: 'M',
    м: 'm',
    Н: 'N',
    н: 'n',
    Њ: 'Nj',
    њ: 'nj',
    О: 'O',
    о: 'o',
    П: 'P',
    п: 'p',
    Р: 'R',
    р: 'r',
    С: 'S',
    с: 's',
    Т: 'T',
    т: 't',
    Ћ: 'Ć',
    ћ: 'ć',
    У: 'U',
    у: 'u',
    Ф: 'F',
    ф: 'f',
    Х: 'H',
    х: 'h',
    Ц: 'C',
    ц: 'c',
    Ч: 'Č',
    ч: 'č',
    Џ: 'Dž',
    џ: 'dž',
    Ш: 'Š',
    ш: 'š'
  };

  return text
    .split('')
    .map((char) => cyrillicMap[char] || char)
    .join('');
};

export const latinToCyrillic = (text) => {
  const latinMap = {
    A: 'А',
    a: 'а',
    B: 'Б',
    b: 'б',
    V: 'В',
    v: 'в',
    G: 'Г',
    g: 'г',
    D: 'Д',
    d: 'д',
    Đ: 'Ђ',
    đ: 'ђ',
    E: 'Е',
    e: 'е',
    Ž: 'Ж',
    ž: 'ж',
    Z: 'З',
    z: 'з',
    I: 'И',
    i: 'и',
    J: 'Ј',
    j: 'ј',
    K: 'К',
    k: 'к',
    L: 'Л',
    l: 'л',
    Lj: 'Љ',
    lj: 'љ',
    M: 'М',
    m: 'м',
    N: 'Н',
    n: 'н',
    Nj: 'Њ',
    nj: 'њ',
    O: 'О',
    o: 'о',
    P: 'П',
    p: 'п',
    R: 'Р',
    r: 'р',
    S: 'С',
    s: 'с',
    T: 'Т',
    t: 'т',
    Ć: 'Ћ',
    ć: 'ћ',
    U: 'У',
    u: 'у',
    F: 'Ф',
    f: 'ф',
    H: 'Х',
    h: 'х',
    C: 'Ц',
    c: 'ц',
    Č: 'Ч',
    č: 'ч',
    Dž: 'Џ',
    dž: 'џ',
    Š: 'Ш',
    š: 'ш'
  };

  return text
    .replace(/Lj/g, 'Љ')
    .replace(/Nj/g, 'Њ')
    .replace(/Dž/g, 'Џ')
    .replace(/lj/g, 'љ')
    .replace(/nj/g, 'њ')
    .replace(/dž/g, 'џ')
    .split('')
    .map((char) => latinMap[char] || char)
    .join('');
};
export const compareObjects = (obj1, obj2) => {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (let key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
};

export const generateTicks = (min, max) => {
  const tickInterval = Math.ceil((max - min) / 5); 
  let ticks = [];

  for (let i = min; i <= max; i += tickInterval) {
    ticks.push(i);
  }

  return ticks;
};
